import React from 'react';

const ErrorMessageComponent = ({ errorMessage }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: errorMessage }} />
  );
};

export default ErrorMessageComponent;
